// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DocumentFullPage.module.css */

.DocumentFullPage_documentarySection__T9zVQ {
  padding: 0;
  background-color: #141414;  /* Netflix black background */
  color: white;
  min-height: 100vh;
}

/* Hero Section */
.DocumentFullPage_heroSection__cZoUa {
  position: relative;
  width: 100%;
  height: 80vh;
  max-height: 700px;
  margin-bottom: 2rem;
}

.DocumentFullPage_heroContent__i1YBC {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.DocumentFullPage_heroOverlay__Ftax7 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.5) 60%,
    rgba(0, 0, 0, 0.3) 100%
  );
  display: flex;
  align-items: center;
}

.DocumentFullPage_heroInfo__TjjQu {
  width: 50%;
  padding: 0 4rem;
}

.DocumentFullPage_heroTitle__PYhXD {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.DocumentFullPage_heroDescription__6PLxX {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  opacity: 0.8;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.DocumentFullPage_watchNowButton__sbuFu {
  display: flex;
  align-items: center;
  background-color: #e50914;  /* Netflix red */
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.DocumentFullPage_watchNowButton__sbuFu:hover {
  background-color: #f40612;
}

.DocumentFullPage_playIcon__WHG66 {
  margin-right: 0.5rem;
}

.DocumentFullPage_heroDots__OWbKi {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
}

.DocumentFullPage_heroDot__F6lkz {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.2s;
}

.DocumentFullPage_activeDot__K-lNH {
  background-color: white;
}

/* Main Content */
.DocumentFullPage_documentariesContainer__s8rvO {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.DocumentFullPage_sectionHeader__TC6z0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2.5rem 0 1.5rem;
}

.DocumentFullPage_pageTitle__Vmhio {
  font-size: 20px;  /* As requested for desktop */
  font-weight: 700;
  margin: 0;
}

.DocumentFullPage_cardContainer__q2bRm {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin: 0 auto;
}

.DocumentFullPage_loading__eqFyS {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
}

.DocumentFullPage_error__p52lg {
  color: #e50914;
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
}

/* Pagination */
.DocumentFullPage_pagination__6mL4X {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
  gap: 1rem;
}

.DocumentFullPage_paginationButton__BE4Dy {
  padding: 0.5rem 1rem;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.DocumentFullPage_paginationButton__BE4Dy:hover:not(.DocumentFullPage_disabled__RYyjB) {
  background-color: #555;
}

.DocumentFullPage_disabled__RYyjB {
  opacity: 0.5;
  cursor: not-allowed;
}

.DocumentFullPage_pageNumbers__Zjfub {
  display: flex;
  gap: 0.5rem;
}

.DocumentFullPage_pageNumber__g24iE {
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.DocumentFullPage_pageNumber__g24iE:hover {
  background-color: #555;
}

.DocumentFullPage_activePage__t5NaX {
  background-color: #e50914;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .DocumentFullPage_cardContainer__q2bRm {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .DocumentFullPage_heroTitle__PYhXD {
    font-size: 2.5rem;
  }
}

@media (max-width: 1024px) {
  .DocumentFullPage_cardContainer__q2bRm {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .DocumentFullPage_heroInfo__TjjQu {
    width: 60%;
  }
}

@media screen and (min-width: 590px) and (max-width: 768px) {
  .DocumentFullPage_cardContainer__q2bRm {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .DocumentFullPage_heroInfo__TjjQu {
    width: 70%;
    padding: 0 2rem;
  }
  
  .DocumentFullPage_heroTitle__PYhXD {
    font-size: 2rem;
  }
  
  .DocumentFullPage_heroDescription__6PLxX {
    font-size: 1rem;
  }
  
  .DocumentFullPage_pageTitle__Vmhio {
    font-size: 18px;
  }
}

@media (max-width: 589px) {
  .DocumentFullPage_cardContainer__q2bRm {
  
    grid-template-columns: repeat(2, 1fr);
  }
  
  .DocumentFullPage_heroSection__cZoUa {
    height: 60vh;
  }
  
  .DocumentFullPage_heroInfo__TjjQu {
    width: 100%;
    padding: 0 1.5rem;
  }
  
  .DocumentFullPage_heroTitle__PYhXD {
    font-size: 1.5rem;
  }
  
  .DocumentFullPage_heroDescription__6PLxX {
    font-size: 0.9rem;
    -webkit-line-clamp: 2;
  }
  
  .DocumentFullPage_watchNowButton__sbuFu {
    padding: 0.6rem 1.5rem;
    font-size: 1rem;
  }
  
  .DocumentFullPage_pageTitle__Vmhio {
    font-size: 16px;
  }
  .DocumentFullPage_sectionHeader__TC6z0{
    margin: 0;
  }
  .DocumentFullPage_heroSection__cZoUa{
    margin-bottom: 10px;
  }
  .DocumentFullPage_documentariesContainer__s8rvO{
    padding: 0;
    max-width: 95%;
    margin: 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/DocumentFullPage.module.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,UAAU;EACV,yBAAyB,GAAG,6BAA6B;EACzD,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,GAAG,gBAAgB;EAC5C,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe,GAAG,6BAA6B;EAC/C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":["/* DocumentFullPage.module.css */\n\n.documentarySection {\n  padding: 0;\n  background-color: #141414;  /* Netflix black background */\n  color: white;\n  min-height: 100vh;\n}\n\n/* Hero Section */\n.heroSection {\n  position: relative;\n  width: 100%;\n  height: 80vh;\n  max-height: 700px;\n  margin-bottom: 2rem;\n}\n\n.heroContent {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n}\n\n.heroOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.8) 0%,\n    rgba(0, 0, 0, 0.5) 60%,\n    rgba(0, 0, 0, 0.3) 100%\n  );\n  display: flex;\n  align-items: center;\n}\n\n.heroInfo {\n  width: 50%;\n  padding: 0 4rem;\n}\n\n.heroTitle {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.heroDescription {\n  font-size: 1.2rem;\n  margin-bottom: 1.5rem;\n  opacity: 0.8;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.watchNowButton {\n  display: flex;\n  align-items: center;\n  background-color: #e50914;  /* Netflix red */\n  color: white;\n  border: none;\n  padding: 0.8rem 2rem;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.watchNowButton:hover {\n  background-color: #f40612;\n}\n\n.playIcon {\n  margin-right: 0.5rem;\n}\n\n.heroDots {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 0.5rem;\n}\n\n.heroDot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.activeDot {\n  background-color: white;\n}\n\n/* Main Content */\n.documentariesContainer {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 2.5rem 0 1.5rem;\n}\n\n.pageTitle {\n  font-size: 20px;  /* As requested for desktop */\n  font-weight: 700;\n  margin: 0;\n}\n\n.cardContainer {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n  margin: 0 auto;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  width: 100%;\n}\n\n.error {\n  color: #e50914;\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.2rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 3rem 0;\n  gap: 1rem;\n}\n\n.paginationButton {\n  padding: 0.5rem 1rem;\n  background-color: #333;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.paginationButton:hover:not(.disabled) {\n  background-color: #555;\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageNumbers {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.pageNumber {\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #333;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pageNumber:hover {\n  background-color: #555;\n}\n\n.activePage {\n  background-color: #e50914;\n}\n\n/* Responsive Styles */\n@media (max-width: 1200px) {\n  .cardContainer {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .heroTitle {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .cardContainer {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .heroInfo {\n    width: 60%;\n  }\n}\n\n@media screen and (min-width: 590px) and (max-width: 768px) {\n  .cardContainer {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .heroInfo {\n    width: 70%;\n    padding: 0 2rem;\n  }\n  \n  .heroTitle {\n    font-size: 2rem;\n  }\n  \n  .heroDescription {\n    font-size: 1rem;\n  }\n  \n  .pageTitle {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 589px) {\n  .cardContainer {\n  \n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .heroSection {\n    height: 60vh;\n  }\n  \n  .heroInfo {\n    width: 100%;\n    padding: 0 1.5rem;\n  }\n  \n  .heroTitle {\n    font-size: 1.5rem;\n  }\n  \n  .heroDescription {\n    font-size: 0.9rem;\n    -webkit-line-clamp: 2;\n  }\n  \n  .watchNowButton {\n    padding: 0.6rem 1.5rem;\n    font-size: 1rem;\n  }\n  \n  .pageTitle {\n    font-size: 16px;\n  }\n  .sectionHeader{\n    margin: 0;\n  }\n  .heroSection{\n    margin-bottom: 10px;\n  }\n  .documentariesContainer{\n    padding: 0;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"documentarySection": `DocumentFullPage_documentarySection__T9zVQ`,
	"heroSection": `DocumentFullPage_heroSection__cZoUa`,
	"heroContent": `DocumentFullPage_heroContent__i1YBC`,
	"heroOverlay": `DocumentFullPage_heroOverlay__Ftax7`,
	"heroInfo": `DocumentFullPage_heroInfo__TjjQu`,
	"heroTitle": `DocumentFullPage_heroTitle__PYhXD`,
	"heroDescription": `DocumentFullPage_heroDescription__6PLxX`,
	"watchNowButton": `DocumentFullPage_watchNowButton__sbuFu`,
	"playIcon": `DocumentFullPage_playIcon__WHG66`,
	"heroDots": `DocumentFullPage_heroDots__OWbKi`,
	"heroDot": `DocumentFullPage_heroDot__F6lkz`,
	"activeDot": `DocumentFullPage_activeDot__K-lNH`,
	"documentariesContainer": `DocumentFullPage_documentariesContainer__s8rvO`,
	"sectionHeader": `DocumentFullPage_sectionHeader__TC6z0`,
	"pageTitle": `DocumentFullPage_pageTitle__Vmhio`,
	"cardContainer": `DocumentFullPage_cardContainer__q2bRm`,
	"loading": `DocumentFullPage_loading__eqFyS`,
	"error": `DocumentFullPage_error__p52lg`,
	"pagination": `DocumentFullPage_pagination__6mL4X`,
	"paginationButton": `DocumentFullPage_paginationButton__BE4Dy`,
	"disabled": `DocumentFullPage_disabled__RYyjB`,
	"pageNumbers": `DocumentFullPage_pageNumbers__Zjfub`,
	"pageNumber": `DocumentFullPage_pageNumber__g24iE`,
	"activePage": `DocumentFullPage_activePage__t5NaX`
};
export default ___CSS_LOADER_EXPORT___;
